import { useRef, useEffect } from 'react';

const AccordionPanel = ({ expanded, children }) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (!wrapperRef.current) return;
        const wrapper = wrapperRef.current;

        if (expanded) {
            wrapper.style.height = `${wrapper.scrollHeight}px`;
            const timeout = setTimeout(() => {
                if (expanded) {
                    wrapper.style.height = 'auto';
                }
            }, 400);
            return () => clearTimeout(timeout);
        } else {
            wrapper.style.height = `${wrapper.scrollHeight}px`;
            wrapper.offsetHeight; // force reflow
            wrapper.style.height = '0px';
        }
    }, [expanded]);

    // Re-measure when children resize (e.g. async iframe load)
    useEffect(() => {
        if (!expanded || !wrapperRef.current) return;
        const wrapper = wrapperRef.current;

        const ro = new ResizeObserver(() => {
            if (wrapper.style.height !== 'auto') {
                wrapper.style.height = `${wrapper.scrollHeight}px`;
            }
        });

        for (const child of wrapper.children) {
            ro.observe(child);
        }
        return () => ro.disconnect();
    }, [expanded]);

    return (
        <div className="panel-wrapper" ref={wrapperRef}>
            {children}
        </div>
    );
};

export default AccordionPanel;
